import React from 'react';
import './Footer.css';
import logoImg from '../assets/images/logo.png';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <img src={logoImg} alt="iPoolCare" className="footer-logo" width={300} height={76} />
          <p className="footer-tagline">De olho na piscina, cuidando de você.</p>
        </div>
        <div className="footer-divider" />
        <p className="footer-copy">&copy; {new Date().getFullYear()} iPoolCare. Todos os direitos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;